import hmacsha256 from 'crypto-js/hmac-sha256'
import enchex from 'crypto-js/enc-hex'
import { getDeepProperty } from '@/helpers/deepObject.js'

export default {
  bootChat (intercom, user, podcast, userPermissions) {
    intercom.boot(this.getFields(user, podcast, userPermissions))
  },
  bootUnAuthedChat (intercom) {
    intercom.boot({})
  },
  getFields (user, podcast, userPermissions, podcastList) {
    const accountCollection = getDeepProperty(user, 'accounts.collection') || []
    const hasCalisto = accountCollection.filter((account) => getDeepProperty(account, 'features.has_calisto')).length > 0
    let creatorId = ''

    podcast = podcast || {}

    try {
      if (podcast.creator) {
        const creatorArray = podcast.creator.href.split('/')
        creatorId = creatorArray[creatorArray.length - 1]
      }

      return {
        user_id: user.id,
        name: user.name,
        email: user.email,
        user_hash: enchex.stringify(hmacsha256(user.id, process.env.INTERCOM_SECRET)),
        'Simplecast Version': '2.0',
        'Active Podcast Title': podcast.title || '',
        'Active Podcast ID': podcast.id || '',
        'Active Podcast Dashboard URL': window.location.origin + '/shows/' + podcast.id,
        'Active Podcast Total Downloads': podcast.downloads || '',
        'Active Podcast RSS Feed URL': podcast.feed_url || '',
        'Active Podcast Status': podcast.status || '',
        'Active Podcast Type': podcast.type || '',
        'Active Podcast Site Link': podcast.site ? `https://${podcast.site.subdomain}.${process.env.PODCAST_SITE_DOMAIN}` : null,
        'Active Podcast Is Delinquent': podcast.is_delinquent || '',
        'Active Podcast Total Episodes': podcast.episodes && podcast.episodes.count,
        'Active Podcast Owner User ID': creatorId,
        'User Owns Active Podcast': user.id === creatorId,
        'User Can Delete Active Podcast': userPermissions.can_delete || '',
        'User Can Edit Active Podcast': userPermissions.can_edit || '',
        'User Can Edit Manager Permissions': userPermissions.can_edit_permissions || '',
        'User Can Publish Active Podcast': userPermissions.can_publish || '',
        'User Can Upload files for Active Podcast': userPermissions.can_upload || '',
        'User Can View Analytics for Active Podcast': userPermissions.can_view_analytics || '',
        'User Permissions Name': userPermissions.name || '',
        'User has Simplecast Plus': !!hasCalisto
      }
    } catch (e) {
      return {}
    }
  },
  updateChat (intercom, user, podcast, userPermissions) {
    intercom.update(this.getFields(user, podcast, userPermissions))
  }
}
